import { BeneficiaryGiftingLinkQuery } from "@ctypes";

export type RequestGiftRouteProps = {
  beneficiaryId?: string;
};

export enum RequestGiftState {
  Initial = "INITIAL",
  Confirmed = "CONFIRMED",
}

export type RequestGiftRouteComponentProps = {
  beneficiaryId: string;
  data: NonNullable<BeneficiaryGiftingLinkQuery["beneficiaryGiftingLink"]>;
  refetch: () => Promise<unknown>;
};
